import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import {
  Card,
  Icon,
  Image,
  Button,
  Label,
  List,
  Divider,
  Grid,
  Header,
  Statistic,
  Segment,
} from 'semantic-ui-react'
import { notEqual } from 'assert'

const Productcard = ({ node }) => (
  <div>
    <Card
      fluid
      centered
      href={`/product/${node.slug}/`}
      style={{
        maxWidth: 600,
      }}
    >
      <Card.Content>
        <div style={{ marginBottom: '10px', textAlign: 'right' }}>
          {node.primaryCategories.slice(0, 1).map(node => (
            <Label
              key={node.id}
              basic
              size="small"
              style={{ marginBottom: '3px' }}
              // color="blue"
            >
              <Icon name="tag" />
              {node.name}
            </Label>
          ))}

          {/* Asks if subcategories exist, if so, maps the array */}
          {node.subCategories ? (
            node.subCategories.slice(0, 2).map(node => (
              <Label
                key={node.id}
                basic
                size="mini"
                style={{ marginBottom: '3px' }}
              >
                {node.name}
              </Label>
            ))
          ) : (
            <span />
          )}
        </div>
        <Grid stackable rows={2}>
          <Grid.Row columns={2}>
            <Grid.Column>
              {/* <Segment basic> */}

              <h2
                style={{
                  color: 'black',
                  fontSize: '2.5em',
                  // fontFamily: 'OpenSans-ExtraBold',
                  fontFamily: 'Open Sans',
                  fontWeight: '800',
                  letterSpacing: '-1.5px',
                }}
              >
                {' '}
                {node.name}
              </h2>

              <List>
                <List.Item>
                  <List.Content>
                    {node.growthLever ? (
                      node.growthLever.map(growthLever => (
                        <Label
                          key={growthLever.id}
                          basic
                          size="tiny"
                          style={{ marginBottom: '3px' }}
                        >
                          <Icon name="rocket" />
                          {growthLever.name}{' '}
                        </Label>
                      ))
                    ) : (
                      <span />
                    )}{' '}
                  </List.Content>
                </List.Item>
              </List>

              <span className="productcardText" style={{ color: 'gray' }}>
                {node.shortDescription}
              </span>
              {/* </Segment> */}
            </Grid.Column>

            <Grid.Column verticalAlign="middle">
              {/* <Image
                  src={node.screenshots[0].file.url}
                  size="medium"
                  centered
                  bordered
                /> */}

              <div>
                <Img
                  resolutions={node.screenshots[0].resolutions}
                  style={{
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    borderColor: '#d4d4d5',
                  }}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row divided columns={3}>
            <Grid.Column>
              {/* <Segment basic> */}
              {/* <Label attached="top">
                  <Icon name="users" />Customers
                </Label> */}
              <List>
                <List.Item>
                  <List.Content>
                    <List.Header style={{ marginBottom: '3px' }}>
                      Budget
                    </List.Header>
                    <List.Description>
                      {node.customerBudget ? (
                        node.customerBudget.map(node => (
                          <span
                            key={node.id}
                            style={{ marginBottom: '3px', marginLeft: '5px' }}
                          >
                            {node.name} <br />
                          </span>
                        ))
                      ) : (
                        <span />
                      )}
                    </List.Description>
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Content>
                    <List.Header style={{ marginBottom: '3px' }}>
                      Industry
                    </List.Header>
                    <List.Description>
                      {node.customerSector ? (
                        node.customerSector.map(node => (
                          <span
                            key={node.id}
                            style={{ marginBottom: '3px', marginLeft: '5px' }}
                          >
                            {node.name} <br />
                          </span>
                        ))
                      ) : (
                        <span />
                      )}
                    </List.Description>
                  </List.Content>
                </List.Item>
              </List>
              {/* </Segment> */}
            </Grid.Column>
            <Grid.Column>
              {/* <Segment basic> */}
              {/* <Label attached="top">
                  <Icon name="dollar" />Pricing
                </Label> */}
              <List>
                <List.Item>
                  <List.Content>
                    <List.Header style={{ marginBottom: '3px' }}>
                      Price
                    </List.Header>
                    <List.Description>
                      <span style={{ marginLeft: '5px' }}>
                        From ${node.startingPrice} per month{' '}
                      </span>
                    </List.Description>
                  </List.Content>
                </List.Item>

                {/* <br /> */}
                <List.Item>
                  <List.Content>
                    {/* <List.Header style={{ marginBottom: '3px' }}>
                        Free Plans & Trials
                      </List.Header> */}

                    {node.freeTrialAvailable ? (
                      <Label
                        color="blue"
                        horizontal
                        style={{ marginBottom: '3px', marginLeft: '5px' }}
                      >
                        Free Trial available
                      </Label>
                    ) : (
                      <span />
                    )}

                    {node.freePlan ? (
                      <Label
                        color="green"
                        horizontal
                        style={{ marginBottom: '3px', marginLeft: '5px' }}
                      >
                        Free Plan
                      </Label>
                    ) : (
                      <span />
                    )}
                  </List.Content>
                </List.Item>

                <List.Item>
                  <List.Header style={{ marginBottom: '3px' }}>
                    Setup difficulty
                  </List.Header>
                  {node.developerRequired ? (
                    <Label
                      color="orange"
                      style={{
                        marginBottom: '3px',
                        marginTop: '3px',
                        marginLeft: '5px',
                      }}
                    >
                      Developer required
                    </Label>
                  ) : (
                    <Label
                      color="green"
                      style={{ marginBottom: '3px', marginLeft: '5px' }}
                    >
                      Simple setup
                    </Label>
                  )}
                </List.Item>
              </List>
              {/* </Segment> */}
            </Grid.Column>
            <Grid.Column>
              {/* <Segment basic> */}
              {/* <Label attached="top">
                  <Icon name="code" />Implementation
                </Label>{' '} */}
              <List>
                <List.Item>
                  <List.Header style={{ marginBottom: '3px' }}>
                    Key Integrations
                  </List.Header>

                  {node.integratesWith ? (
                    node.integratesWith.slice(0, 7).map(node => (
                      <span
                        key={node.id}
                        style={{
                          marginBottom: '3px',
                          marginLeft: '5px',
                          color: 'gray',
                        }}
                      >
                        {node.name} <br />
                      </span>
                    ))
                  ) : (
                    <span />
                  )}
                </List.Item>
              </List>
              {/* </Segment> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {/* <div className="ui two buttons">
          <Button basic><a href={node.website} target='_blank'>Visit website <Icon name='external' /></a></Button>
          <Button primary>View profile</Button>
        </div> */}
      </Card.Content>
    </Card>
  </div>
)

export default Productcard



// WEBPACK FOOTER //
// ./src/components/productcard.js